var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubirarchivo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 29.1667V55.4167M35.0001 29.1667L43.7501 37.9167M35.0001 29.1667L26.2501 37.9167M51.0417 43.75C55.4721 43.75 58.3334 40.1596 58.3334 35.7292C58.3332 33.9752 57.7581 32.2696 56.6961 30.8736C55.6341 29.4776 54.1438 28.4682 52.4534 28C52.1933 24.7289 50.8376 21.641 48.6054 19.2357C46.3732 16.8304 43.395 15.2483 40.1524 14.745C36.9097 14.2418 33.5921 14.8469 30.7359 16.4626C27.8797 18.0782 25.6518 20.6099 24.4126 23.6484C21.8034 22.9251 19.0138 23.268 16.6574 24.6015C14.301 25.935 12.5708 28.15 11.8476 30.7592C11.1243 33.3684 11.4671 36.158 12.8007 38.5144C14.1342 40.8708 16.3492 42.6009 18.9584 43.3242",
    stroke: "#8E96A8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubirarchivo);
export default __webpack_public_path__ + "static/media/subirarchivo.aff3c2bab96b6c21e53be67e381992bb.svg";
export { ForwardRef as ReactComponent };